export default __webpack_public_path__ + "static/media/NLinn_Resume.029f6041.pdf";